import styled, { css } from 'styled-components';

const SuffixIcon = styled.button(({ theme: { olist: { components: { input }, }, }, }) => css `
    background: none;
    border: none;
    color: ${input.suprefix.color};
    display: flex;
    padding: 0;
    cursor: pointer;
  `);

export { SuffixIcon };
